import React from "react";
import { Box, Typography } from "@material-ui/core";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { useLocation } from "Hooks/useRouter";
import ExternalRoutes from "Shared/Constants/ExternalRoutes";
import useStyles from "./styles";

export function InfoBanner() {
  const classes = useStyles();
  const { loading, offCyclePaymentOptions, currentProvider } =
    usePartnerConfig();
  const { pathname } = useLocation();

  // we only support cycle banner for now
  if (
    pathname !== "/" ||
    loading ||
    currentProvider?.whiteLabelPartnerIdentifier !== "dailypay" ||
    offCyclePaymentOptions.enableOffCycleDisbursements
  ) {
    return <></>;
  }

  return (
    <Box className={classes.container}>
      {currentProvider?.whiteLabelPartnerIdentifier === "dailypay" &&
        !offCyclePaymentOptions.enableOffCycleDisbursements && (
          <Box pt="3">
            <a
              href={ExternalRoutes.cycleProduct}
              className={classes.link}
              target="_blank"
              rel="noreferrer"
            >
              <Typography className={classes.banner}>
                Introducing Cycle on DailyPay - Contact your Partnership Manager
                to learn more about Cycle
              </Typography>
            </a>
          </Box>
        )}
    </Box>
  );
}
